// CacheKey f0eb1e6b8b3fb17aac43ad6260091f9e
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-NCQA": {
    simple_form: {
      labels: {
        encounter: {
          has_ami: "Influenza Gap",
          has_chf: "Cardiovascular Conditions (CAD) Gap",
          has_copd_asthma: "Inactive Patient Gap",
          has_pneumo: "Diabetes Care Eye Exam Gap",
          has_sepsis: "Diabetes Care HbA1C Gap",
          has_stroke: "Diabetes Care Statin Adherence Gap",
          has_central_line: "Peds Wellness Visit Gap",
          unit_id: "Site Name",
          unit_name: "Site Name",
          risk_score_1_on_discharge: "Risk Level",
          risk_score_2_on_discharge: "Number of Chronic Conditions"
        }
      }
    }
  }
}

